"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newDataSetMetadataObject = exports.DataSetMetadataObjectBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var factory_1 = require("./factory");
var builder_1 = require("../builder");
/**
 * DataSet metadata object builder
 * See {@link Builder}
 *
 * @beta
 */
var DataSetMetadataObjectBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(DataSetMetadataObjectBuilder, _super);
    function DataSetMetadataObjectBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DataSetMetadataObjectBuilder;
}(factory_1.MetadataObjectBuilder));
exports.DataSetMetadataObjectBuilder = DataSetMetadataObjectBuilder;
/**
 * DataSet metadata object factory
 *
 * @param ref - dataset reference
 * @param modifications - dataset builder modifications to perform
 * @returns created dataset metadata object
 * @beta
 */
exports.newDataSetMetadataObject = function (ref, modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    return builder_1.builderFactory(DataSetMetadataObjectBuilder, { type: "dataSet", ref: ref }, modifications);
};
//# sourceMappingURL=dataSetFactory.js.map